export default {
  en: {
    title: 'Attendance System',
    welcome: 'Welcome! Please select your action below',
    clockIn: 'Clock In',
    clockOut: 'Clock out',
    clockInDesc: 'Record your arrival time',
    clockOutDesc: 'Record your departure time',
    recentActivity: 'Recent Activity',
    noRecentActivity: 'No recent activity',
    arrived: 'Arrived',
    left: 'Left',
    selectedMode: 'Selected Mode',
    changeMode: 'Change Mode',
    startingCamera: 'Starting Camera...',
    positionFace: 'Position your face in the frame',
    processingText: 'Processing...',
    noFaceDetected: 'No face detected. Please position your face in the frame.',
    moveLeft: 'Move your face left',
    moveRight: 'Move your face right',
    moveUp: 'Move your face up',
    moveDown: 'Move your face down',
    moveCloser: 'Please move closer to the camera',
    moveBack: 'Please move back from the camera',
    goodPosition: 'Face position good! Hold still...',
    holdStill: 'Hold still, processing...',
    clockOutNow: 'Clock Out Now',
    clockInNow: 'Clock In Now',
    newVerification: 'New Verification',
    returningIn: 'Returning in',
    seconds: 'seconds',
    verificationFailed: 'Verification failed',
    cameraError: 'Camera error. Please check permissions.',
    selectAction: 'Select Clock In or Clock Out',
    alreadyClockedIn: "You are already clocked in.",
    needsClockIn: "You need to clock in first.",
    welcomeUser: 'Welcome, {name}!',
    goodbye: 'Goodbye, {name}! Have a great day!',
    clockInSuccess: 'Clock In Successful!',
    clockOutSuccess: 'Clock Out Successful!',
    failedClockIn: 'Failed to clock in. Please try again.',
    failedClockOut: 'Failed to clock out. Please try again.',
    faceNotRecognized: 'Face not recognized, trying again...',
    clockingIn: 'Clocking In',
    clockingOut: 'Clocking Out',
    cancel: 'Cancel',
    processing: 'Processing...',
  },
  es: {
    title: 'Sistema de Asistencia',
    welcome: '¡Bienvenido! Por favor seleccione su acción',
    clockIn: 'Registrar Entrada',
    clockOut: 'Registrar Salida',
    clockInDesc: 'Registrar hora de llegada',
    clockOutDesc: 'Registrar hora de salida',
    recentActivity: 'Actividad Reciente',
    noRecentActivity: 'Sin actividad reciente',
    arrived: 'Llegó',
    left: 'Salió',
    selectedMode: 'Modo Seleccionado',
    changeMode: 'Cambiar Modo',
    startingCamera: 'Iniciando Cámara...',
    positionFace: 'Posicione su rostro en el marco',
    processingText: 'Procesando...',
    noFaceDetected: 'No se detectó rostro. Por favor posicione su rostro en el marco.',
    moveLeft: 'Mueva su rostro a la izquierda',
    moveRight: 'Mueva su rostro a la derecha',
    moveUp: 'Mueva su rostro hacia arriba',
    moveDown: 'Mueva su rostro hacia abajo',
    moveCloser: 'Por favor acérquese a la cámara',
    moveBack: 'Por favor aléjese de la cámara',
    goodPosition: '¡Buena posición! Manténgase quieto...',
    holdStill: 'Manténgase quieto, procesando...',
    clockOutNow: 'Registrar Salida Ahora',
    clockInNow: 'Registrar Entrada Ahora',
    newVerification: 'Nueva Verificación',
    returningIn: 'Volviendo en',
    seconds: 'segundos',
    verificationFailed: 'Verificación fallida',
    cameraError: 'Error de cámara. Por favor revise los permisos.',
    selectAction: 'Seleccione Entrada o Salida',
    alreadyClockedIn: "Ya has registrado tu entrada.",
    needsClockIn: "Necesitas registrar tu entrada primero.",
    welcomeUser: '¡Bienvenido, {name}!',
    goodbye: '¡Adiós, {name}! ¡Que tengas un buen día!',
    clockInSuccess: '¡Entrada Registrada con Éxito!',
    clockOutSuccess: '¡Salida Registrada con Éxito!',
    failedClockIn: 'Error al registrar entrada. Por favor intente nuevamente.',
    failedClockOut: 'Error al registrar salida. Por favor intente nuevamente.',
    faceNotRecognized: 'Rostro no reconocido, intentando nuevamente...',
    clockingIn: 'Registrando Entrada',
    clockingOut: 'Registrando Salida',
    cancel: 'Cancelar',
    processing: 'Procesando...',
  }
} 